package org.multiplatform.kotfolio.styles

import com.varabyte.kobweb.compose.css.FontWeight
import com.varabyte.kobweb.compose.css.Overflow
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.modifiers.borderRadius
import com.varabyte.kobweb.compose.ui.modifiers.display
import com.varabyte.kobweb.compose.ui.modifiers.fillMaxWidth
import com.varabyte.kobweb.compose.ui.modifiers.fontFamily
import com.varabyte.kobweb.compose.ui.modifiers.fontSize
import com.varabyte.kobweb.compose.ui.modifiers.fontWeight
import com.varabyte.kobweb.compose.ui.modifiers.lineHeight
import com.varabyte.kobweb.compose.ui.modifiers.maxWidth
import com.varabyte.kobweb.compose.ui.modifiers.overflow
import com.varabyte.kobweb.compose.ui.modifiers.padding
import com.varabyte.kobweb.silk.style.CssStyle
import org.jetbrains.compose.web.css.DisplayStyle
import org.jetbrains.compose.web.css.cssRem
import org.jetbrains.compose.web.css.px
import com.varabyte.kobweb.silk.style.breakpoint.Breakpoint
import org.jetbrains.compose.web.css.percent
import org.jetbrains.compose.web.css.vw

val KotlinCodeStyle = CssStyle {
    base {
        Modifier
            .display(DisplayStyle.Block)
            .fillMaxWidth()
            .borderRadius { 0.25.cssRem }
            .fontFamily("SFMono-Regular", "Menlo", "Consolas", "monospace")
            .fontSize(12.px)
            .fontWeight(FontWeight.Normal)
            .lineHeight(1.9.cssRem)
            .padding(0.75.cssRem)
            .overflow { x(Overflow.Auto) }
    }
    Breakpoint.MD { Modifier.maxWidth(100.percent) }
}


